<template>
  <div class="GroupNotice">
    <van-nav-bar title="群公告" fixed left-arrow @click-left="onClickLeft" @click-right="onClickRight">
      <template #right v-if="ug_admin_id == u_id || group_manage==1">
        <span class="van-nav-bar__text">编辑</span>
      </template>
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-field
        autosize
        type="textarea"
        v-model="groupNotice"
        border
        clearable
        v-if="ug_admin_id == u_id || group_manage==1"
      />
      <div v-else v-html="groupNotice" class="txt"></div>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  name: "ShowGroupManage",
  data() {
    return {
      ug_id: "",
      groupNotice: "",
      checked: false,
      data: [],
      ug_admin_id: "",
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      group_manage: localStorage.getItem("group_manage")
    };
  },
  created() {
    var params = this.$route.query;
    this.ug_id = params.ug_id;
    this.ug_admin_id = params.ug_admin_id;
    this.loadData();
  },
  methods: {
    loadData() {
      var params = {
        u_id: this.u_id,
        token: this.token,
        ug_id: this.ug_id
      };
      var url = this.Conf.serverUrl + "Groups/getGroupNotice";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          if (response.data.code == 200) {
            this.groupNotice = response.data.notice.ug_notice;
          }
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "GroupChatSet",
        query: {
          ug_id: this.ug_id
        }
      });
    },
    // 编辑按钮
    onClickRight() {
      var params = {
        u_id: this.u_id,
        ug_id: this.ug_id,
        token: this.token,
        ug_notice: this.groupNotice
      };
      var url = this.Conf.serverUrl + "Groups/groupNotice";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              this.$toast.success(response.data.msg);
              this.onClickLeft();
              break;
            case 40001:
              this.$toast.fail(response.data.msg);
              break;
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Group/GroupNotice.vue